import { createFileRoute } from "@tanstack/react-router";
import BusinessEmail from "@/pages/BusinessEmail";

export const Route = createFileRoute("/business-email")({
  component: BusinessEmail,
});
